import * as Yup from 'yup'

const ImageCategorySchema = Yup.object().shape({
  name: Yup.string()
    .required('Campo requerido'),
  description: Yup.string().nullable()
})

export default ImageCategorySchema